import { AvailableTimeMinutes, DeliveryTypeProduct } from '@app/entities/Delivery';
import {
  ShopType,
  sortByDistance,
  sortByFieldSort,
  sortByQuantityNoToday,
  sortByQuantityToday,
  sortByStatusDeliveryNoToday,
  sortByStatusDeliveryToday,
  sortPartner,
} from '@entities/Shop';

// формирования массива магазинов по наличию товара
export function formingAnArraySBOPA(shops: ShopType[]): ShopType[] {
  const pickUpToday = shops
    ?.filter(shop => shop.type.includes(DeliveryTypeProduct.Today))
    .sort(sortByQuantityToday)
    .sort(sortByDistance)
    .sort(sortByStatusDeliveryToday)
    .sort(sortPartner);

  const pickUpLater = shops
    ?.filter(shop => shop.type.includes(DeliveryTypeProduct.NotToday))
    // .sort(sortByFieldSort)
    .sort(sortByQuantityNoToday)
    .sort(sortByDistance)
    .sort(sortByStatusDeliveryNoToday)
    .sort(sortPartner);

  const arrayShop = [...pickUpToday, ...pickUpLater.filter(shop => !pickUpToday.some(x => shop.shopId === x.shopId))];

  return arrayShop;
}

export function filterIsHideTwoHours(shops: ShopType[]): ShopType[] {
  return shops.filter(shop => shop.statusDeliveryToday !== AvailableTimeMinutes.CONST_TWO_HOURS);
}
